import validator from 'validator';

class ValidateFields {

    validateEmail(email: string) {
        if (validator.isEmpty(email)) {
            return 'Email is required';
        } else if (!validator.isEmail(email)) {
            return 'Invalid Email';
        }
        return false;
    }
    // validatePassword(password: string) {
    //     let regex = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&.,<>?/*:";'{}()=\[\]+_\-])[A-Za-z\d~!@#$%^&.,<>?/*:";'{}()[]=+_-]{8,16}$/)
    //     if (validator.isEmpty(password)) {
    //         return 'Please Enter Password';
    //     } else if (!validator.isLength(password, { min: 8, max: 15 })) {
    //         return 'Password should be between 8 and 15 characters';
    //     } else if (regex.test(password)) {
    //         return "Password must have uppercase, lowercase, special character and number."
    //     }
    //     return false;
    // }
  // New Add 
  containsEmoji(str: string) {
  const emojiRegex =
    /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F700}-\u{1F77F}]|[\u{1F780}-\u{1F7FF}]|[\u{1F800}-\u{1F8FF}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA00}-\u{1FA6F}]|[\u{1FA70}-\u{1FAFF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{FE00}-\u{FE0F}]|[\u{1F018}-\u{1F270}]|[\u{1F1E6}-\u{1F1FF}]/u;

  return emojiRegex.test(str);
}

    validatePassword(password: string) {
        if (validator.isEmpty(password)) {
            return 'Please Enter Password.';
        }
        else if (!validator.isLength(password, { min: 8, max: 15 })) {
            return 'Password should be between 8 and 15 characters.';
        }
       else if (this.containsEmoji(password)) {
            return 'Confirm Password should not contain emoji characters.';
        }
        else if (/\s/.test(password)) {
            return 'Password should not contain spaces.';
        }
        return false;
    }
    



    validateFirstName(firstname: string) {
        if (validator.isEmpty(firstname.trim())) {
            return 'First Name is required';
        }
        return false;
    }

    validateLastName(lastname: string) {
        if (validator.isEmpty(lastname.trim())) {
            return 'Last Name is required';
        }
        return false;
    }

  

    validateConfirmPassword(password: string, confirmPassword: string) {
        if (validator.isEmpty(confirmPassword)) {
            return 'Please Enter Confirm Password.';
        } else if (!validator.isLength(confirmPassword, { min: 8, max: 16 })) {
            return 'Confirm Password should be between 8 and 15 characters.'
        }else if (this.containsEmoji(confirmPassword)) {
            return 'Confirm Password should not contain emoji characters.';
        }
        else if (password !== confirmPassword) {
            return "Password doesn't match";
        }
        return false;
    }

    validateShopperType(shoppertype: string) {
        if (validator.isEmpty(shoppertype.trim())) {
            return 'Shopper Type is required';
        }
        return false;
    }

    validatePostalCode(postalcode: string) {
        if (!postalcode) {
            return 'Postal Code is required';
        }
        return false;
    }


    validateCountryCode(countrycode: string) {
        if (!countrycode) {
            return 'Country Code is required';
        }
        return false;
    }



    validatePhoneNumber(phone: string) {
        if (!phone) {
            return 'Phone Number is required';
        } else if (phone.length != 10) {
            return 'Phone Number Must be 10 Digits';
        }
        return false;
    }

    validateName(name: string) {
        if (!name) {
            return 'Name is required';
        }
        return false;
    }

    validateDescription(description: string) {
        if (!description) {
            return 'Description is required';
        }
        return false;
    }


    validateStaffRole(description: string) {
        if (!description) {
            return 'Please Select the Staff Role';
        }
        return false;
    }

}

const validateFields = new ValidateFields();

export { validateFields };